import React from 'react'
import { EditPersonalDetails } from 'src/component/profile/personal-info/personal-details/edit-personal-details'
import { ReadPersonalDetails } from 'src/component/profile/personal-info/personal-details/read-personal-details'
import { useEditMode } from 'src/hook/use-edit-mode'

export const PersonalDetails = (): React.ReactElement => {
  const { isEditing, handleEdit, handleCancel, handleSave } = useEditMode()

  return isEditing ? (
    <EditPersonalDetails onSave={handleSave} onCancel={handleCancel} />
  ) : (
    <ReadPersonalDetails onEdit={handleEdit} />
  )
}
